import { startOfToday } from "../../Utils/dateRange";

const complaintsReducer = (
  state = {
    loading: false,
    complaintsCount: {
      total: 0,
      customerSupport: 0,
      public: 0,
      internal: 0,
      independentEngineer: 0
    },
    range: { from: startOfToday(), to: Date.now() }
  },
  action
) => {
  switch (action.type) {
    case "SET_COMPLAINTS_LOADING":
      return { ...state, loading: action.payload.loading };

    case "SET_COMPLAINTS_COUNT_DATA":
      return {
        ...state,
        complaintsCount: action.payload.count,
        range: action.payload.range ?? state.range
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};

export default complaintsReducer;
